export default "__VITE_ASSET__DlJa4RjN__"